<canvas class=map  id="{{mapCanvasId}}" width={{width}} height={{height}}>Canvas for Making a stage!</canvas>
